import React from "react";
import Transaction_Form from "./Transaction_Form";
import {connect} from "react-redux";
import {Update_Transaction_With_Firebase} from "../../actions/Transaction";

const Edit_Transaction_Page = (props) => {
    return (
        <div>
            <Transaction_Form
                Transaction={props.Transaction}
                onSubmit={(transaction) => {
                    props.Update_Transaction_With_Firebase(props.Transaction.id, transaction);
                    props.history.push("/dashboard");
                }}
                button_name="Edit Transaction"
                form_name="Edit Transaction"
            />
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        Transaction: state.Transaction.find((transaction) => {
            return transaction.id === props.match.params.id;
        })
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        Update_Transaction_With_Firebase: (id, updates) => dispatch(Update_Transaction_With_Firebase(id, updates))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Edit_Transaction_Page);

